import React, { useState, useEffect } from 'react';
import {
  Box,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  Chip,
  Button,
  CircularProgress,
} from '@mui/material';
import { listReceipts, approveReceipt, rejectReceipt } from '../../services/api';
import { UnloadingReceipt } from '../../types';

function ReceiptQueue() {
  const [receipts, setReceipts] = useState<UnloadingReceipt[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadReceipts();
  }, []);

  const loadReceipts = async () => {
    try {
      setLoading(true);
      const result = await listReceipts();
      setReceipts(result.receipts);
    } catch (err) {
      console.error('Error loading receipts:', err);
    } finally {
      setLoading(false);
    }
  };

  const handleApprove = async (receiptId: string) => {
    try {
      await approveReceipt(receiptId);
      loadReceipts();
    } catch (err) {
      console.error('Error approving receipt:', err);
    }
  };

  const handleReject = async (receiptId: string) => {
    const reason = prompt('Enter rejection reason:');
    if (reason) {
      try {
        await rejectReceipt(receiptId, reason);
        loadReceipts();
      } catch (err) {
        console.error('Error rejecting receipt:', err);
      }
    }
  };

  if (loading) {
    return <CircularProgress />;
  }

  return (
    <Box>
      <Typography variant="h6" gutterBottom>
        Receipt Queue
      </Typography>
      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Receipt ID</TableCell>
              <TableCell>Provider</TableCell>
              <TableCell>Amount</TableCell>
              <TableCell>Date</TableCell>
              <TableCell>Status</TableCell>
              <TableCell>Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {receipts.length === 0 ? (
              <TableRow>
                <TableCell colSpan={6} align="center">
                  No receipts found
                </TableCell>
              </TableRow>
            ) : (
              receipts.map((receipt) => (
                <TableRow key={receipt.receipt_id}>
                  <TableCell>{receipt.receipt_id.substring(0, 8)}</TableCell>
                  <TableCell>{receipt.provider_name || 'N/A'}</TableCell>
                  <TableCell>
                    {receipt.amount
                      ? `${receipt.currency || 'BRL'} ${receipt.amount.toFixed(2)}`
                      : 'N/A'}
                  </TableCell>
                  <TableCell>{receipt.date || 'N/A'}</TableCell>
                  <TableCell>
                    <Chip
                      label={receipt.status || 'pending'}
                      color={
                        receipt.status === 'approved'
                          ? 'success'
                          : receipt.status === 'rejected'
                          ? 'error'
                          : 'warning'
                      }
                      size="small"
                    />
                  </TableCell>
                  <TableCell>
                    <Button
                      size="small"
                      onClick={() => handleApprove(receipt.receipt_id)}
                      disabled={receipt.status === 'approved'}
                    >
                      Approve
                    </Button>
                    <Button
                      size="small"
                      color="error"
                      onClick={() => handleReject(receipt.receipt_id)}
                      disabled={receipt.status === 'rejected'}
                    >
                      Reject
                    </Button>
                  </TableCell>
                </TableRow>
              ))
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
}

export default ReceiptQueue;

